import { faBriefcase, faUser } from "@fortawesome/fontawesome-free-solid";
import {
  faCircleCheck,
  faPencil,
  faTriangleExclamation,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { useState } from "react";
import { useDispatch } from "react-redux";
import Modal from "../Modal";

const VehicleTypeItem = ({
  id,
  vehicleImage,
  vehicleType,
  description,
  personCount,
  luggageCount,
  status,
  categoryType,
}) => {
  const dispatch = useDispatch();
  const [showModal, setShowModal] = React.useState(false);
  const [vehicleImageUpdate, setvehicleImageUpdate] = useState(vehicleImage);
  const [vehicleCategoryImage, setvehicleCategoryImage] = useState();

  const [vehicleDetails, setvehicleDetails] = useState({
    vehicleName: vehicleType,
    description: description,
    personCount: personCount,
    luggageCount: luggageCount,
    status: status,
  });

  const formData = new FormData();

  const updateVehicleHandler = () => {
    vehicleImageUpdate?.name &&
      formData.append("vehicleImage", vehicleImageUpdate);
    formData.append("vehicleName", vehicleDetails.vehicleName);
    formData.append("description", vehicleDetails.description);
    formData.append("passengerCount", parseInt(vehicleDetails.personCount));
    formData.append("luggageCount", parseInt(vehicleDetails.luggageCount));
    formData.append("status", vehicleDetails.status);

    //

    dispatch({
      type: "UPDATE_VEHICLE",
      payload: {
        vehicleId: id,
        body: formData,
      },
    });
    setShowModal(false);
  };

  return (
    <div className="relative mt-24 mb-3">
      <div className="bg-gray-50 h-[320px] w-[22rem] shadow-md rounded-md border border-gray-200 font-sans text-red-600 hover:shadow-xl">
        <div className="absolute -translate-y-24 translate-x-1/4 sm:translate-x-[10%]">
          <img
            className="h-40 w-auto object-fit pl-[5%]"
            src={vehicleImage}
            alt="car"
          />
        </div>
        <div className="text-[#fb4156] text-xl font-semibold text-center mt-20">
          {vehicleType}
        </div>
        <div className="mx-5 mt-5">
          <div className="flex space-x-1 items-center text-xs mb-2">
            <div className="text-sm text-gray-600 font-bold font-body">
              Category:
            </div>
            <div className="text-gray-800 font-semibold font-body">
              {categoryType}
            </div>
          </div>
          <div className="h-10 mb-16 font-bold text-gray-600  font-body">
            Description: <br />
            <div className="text-sm font-normal text-black font-body">
              {description}
            </div>
          </div>
        </div>
        <div className="flex justify-around mt-2 mb-2">
          <div className="items-center text-center">
            <FontAwesomeIcon icon={faUser} className="text-sm" />
            <div className="text-black text-sm font-body">
              {personCount} Max
            </div>
          </div>
          <div className="items-center text-center">
            <FontAwesomeIcon icon={faBriefcase} className="text-sm" />
            <div className=" text-black text-sm font-body">
              {luggageCount} Max
            </div>
          </div>
          <div className="items-center text-center">
            {status === "ACTIVE" ? (
              <FontAwesomeIcon
                icon={faCircleCheck}
                className="text-sm text-green-700"
              />
            ) : (
              <FontAwesomeIcon
                icon={faTriangleExclamation}
                className="text-sm text-red-700"
              />
            )}
            <div className=" text-black text-sm font-body">Status</div>
          </div>
          <div>
            <button
              className="items-center text-center"
              onClick={() => {
                setShowModal(true);
              }}
            >
              <FontAwesomeIcon icon={faPencil} className="text-sm" />
              <div className=" text-black text-sm font-body">Edit</div>
            </button>

            {/* Start of Main modal */}

            {showModal ? (
              <>
                <Modal
                  heading="Edit Vehicle"
                  cancelOnClick={() => {
                    setShowModal(false);
                  }}
                  addOnClick={updateVehicleHandler}
                  addButtonLabel="Save"
                  isVehicleEdit={true}
                  vehicleImageInput={(e) => {
                    setvehicleImageUpdate(e.target.files[0]);
                  }}
                  vehicleCategoryImageInput={(e) => {
                    setvehicleCategoryImage(e.target.files[0]);
                  }}
                  vehicleId={id}
                  vehicleImage={vehicleImageUpdate}
                  vehicleCategoryImage={vehicleCategoryImage}
                  vehicleTypeValue={vehicleDetails?.vehicleName}
                  vehicleTypeInput={(e) => {
                    setvehicleDetails({
                      ...vehicleDetails,
                      vehicleType: e.target.value,
                    });
                  }}
                  vehicleDescriptionValue={vehicleDetails?.description}
                  vehicleDescription={(e) => {
                    setvehicleDetails({
                      ...vehicleDetails,
                      description: e.target.value,
                    });
                  }}
                  noOfPassengerValue={vehicleDetails.personCount}
                  noOfPassenger={(e) => {
                    setvehicleDetails({
                      ...vehicleDetails,
                      personCount: e.target.value,
                    });
                  }}
                  noOfLuggageValue={vehicleDetails.luggageCount}
                  noOfLuggage={(e) => {
                    setvehicleDetails({
                      ...vehicleDetails,
                      luggageCount: e.target.value,
                    });
                  }}
                  vehicleStatusValue={vehicleDetails.status}
                  vehicleStatusChange={(e) => {
                    setvehicleDetails({
                      ...vehicleDetails,
                      status: e.target.value,
                    });
                  }}
                />
                <div
                  className="fixed inset-0 z-40 bg-black opacity-25"
                  onClick={() => {
                    setShowModal(false);
                  }}
                ></div>
              </>
            ) : null}
            {/* End of Main modal */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default VehicleTypeItem;
